import { render } from "./Sidebar.vue?vue&type=template&id=9cac94b6&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=9cac94b6&lang=scss"

import exportComponent from "/home/deploy/wesgroup-production/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__